import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { map, startWith, switchMap, take } from 'rxjs/operators';
import { ExamScriptComponent } from './exam-script/exam-script.component';
import { ExamFeedbackComponent } from './exam-feedback/exam-feedback.component';
import { QuestionReportComponent } from './question-report/question-report.component';
import { ExamResultComponent } from './exam-result/exam-result.component';
import { ExamResultCardComponent } from './exam-result-card/exam-result-card.component';
import { ExamResultCategoryComponent } from './exam-result-category/exam-result-category.component';
import { id } from 'date-fns/locale';
import { GenerateMarkSheetComponent } from './generate-mark-sheet/generate-mark-sheet.component';
import { ExamScoreByIpComponent } from './exam-score-by-ip/exam-score-by-ip.component';
import { ExaminersMarkingReportComponent } from './exam-examiners-marking-report/exam-examiners-marking-report.component';
import { ExaminersReviewReportComponent } from './exam-examiners-review-report/exam-examiners-review-report.component';
import { ExamMarkingSummaryReportComponent } from './exam-marking-summary-report/exam-marking-summary-report.component';
import { ExamScoreByMacComponent } from './exam-score-by-mac/exam-score-by-mac.component';
import { ExamService } from 'src/app/services/exam-service.service';
import { ExamQuestionAnalysisExcelComponent } from './exam-question-analysis-excel/exam-question-analysis-excel.component';
import { GenericConfirmComponent } from 'src/app/shared-layout/generic-confirm/generic-confirm.component';
import { ExamResultPeriodComponent } from './exam-result-period/exam-result-period.component';
import { IExam } from 'src/app/interface/dto';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ExamReportService {

  opOpen$: Observable<boolean> = of(false);
  emitValue = new EventEmitter<any>();
  exam: IExam = null;

  constructor(private popoverService: PopoverService, private router: Router, private examService: ExamService, private snackBar: SnackbarService,) { }

  async processExamReport(route: any, origin: any) {
    if (route == 'report/exam/result/period') {
      this.openModal(origin, ExamResultPeriodComponent);
      return;
    }
    this.exam = this.examService.selectedExams?.length === 1 ? this.examService.selectedExams[0] : null;
    if (this.examService.selectedExams?.length === 0) {
      if (this.exam == null || this.examService.selectedExams?.length <= 0) {
        this.snackBar.warning('No Examination Selected');
        return false;
      }
    }
    else if (this.examService.selectedExams?.length > 1 ) {
      this.snackBar.warning('Multiple Examinations Selected');
      return false;
    }

    if (route == 'report/exam/script') {
      this.openModal(origin, ExamScriptComponent);
      return;
    }
    if (route == 'report/exam/feedback/1') {
      sessionStorage.setItem("value", "1");
      this.openModal(origin, ExamFeedbackComponent);
      return;
    }
    if (route == 'report/exam/feedback/2') {
      sessionStorage.setItem("value", "2");
      this.openModal(origin, ExamFeedbackComponent);
      return;
    }
    if (route == 'report/exam/question') {
      this.openModal(origin, QuestionReportComponent);
      return;
    }

    if (route == 'report/exam/result') {
      this.openModal(origin, ExamResultComponent);
      return;
    }
    if (route == 'report/exam/result/card') {
      this.openModal(origin, ExamResultCardComponent);
      return;
    }
    if (route == 'report/exam/result/category') {
      this.openModal(origin, ExamResultCategoryComponent);
      return;
    }
    if (route == 'report/exam/mark-sheet') {
      this.openModal(origin, GenerateMarkSheetComponent);
      return;
    }
    if (route == 'report/exam/scoreip') {
      this.openModal(origin, ExamScoreByIpComponent);
      return;
    }
    if (route == 'report/exam/examinersmarking') {
      this.openModal(origin, ExaminersMarkingReportComponent);
      return;
    }
    if (route == 'report/exam/examinersreview') {
      this.openModal(origin, ExaminersReviewReportComponent);
      return;
    }
    if (route == 'report/exam/exammarkingsummary') {
      this.openModal(origin, ExamMarkingSummaryReportComponent);
      return;
    }
    if (route == 'report/exam/macAddress') {
      this.openModal(origin, ExamScoreByMacComponent);
      return;
    }
    if (route == 'report/exam/view-script') {
      this.openSAQConfirm(origin);
      return;
    }
    if(route == 'report/exam/question-analysis'){
      this.router.navigate([`exams/${this.examService.selectedExamIds}/question-analysis`])
      return;
    }
    if (route == 'report/exam/question-analysis-excel') {
      this.openModal(origin, ExamQuestionAnalysisExcelComponent);
      return;
    }
    if (route == 'report/exam/psychometric-report') {
      this.router.navigate([`exams/${this.examService.selectedExamIds}/psychometric-report`]);
      return;
    }
  }

  openModal(origin: any, _class: any) {
    this.opOpen$ = of(
      this.popoverService.open({
        content: _class,
        origin,
        width: 2000,
        offsetY: 12,
        position: [
          {
            originX: 'end',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center'
          }, {
            originX: 'end',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openSAQConfirm(origin) {
    let exam = this.examService.selectedExams[0];
    let excludeTestCandidates = true;
    const popover = this.popoverService.open({
      content: GenericConfirmComponent,
      origin: origin,
      width: 2000,
      offsetY: 12,
      data: { message: 'Do you want to exclude test candidates?' },
      position: [
        {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'top'
        }, {
          originX: 'end',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popover.afterClosed$
      .pipe(take(1))
      .subscribe(async (result: any) => {
        console.log("Closing..");
        
        if (result.data === true) {
          excludeTestCandidates = true;
        }else{
          excludeTestCandidates = false;
        }
        if (exam.examinationTypeenum === "SAQ") {
          const popover = this.popoverService.open({
            content: GenericConfirmComponent,
            origin: origin,
            width: 2000,
            offsetY: 12,
            data: { message: 'Do you want to show only answered Short Answer Question?' },
            position: [
              {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'top'
              }, {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'top'
              }
            ]
          });

          popover.afterClosed$
            .pipe(take(1))
            .subscribe(async (result: any) => {
              let show = false;
              if (result.data === true) {
                show = true;
              }
              // this.po.close();
              this.router.navigate([`exams/${this.examService.selectedExamIds}/view-script`], {
                queryParams: { showUnansweredSAQ: show, excludeTestCandidates: excludeTestCandidates }
              })
            });
        } else {
          this.router.navigate([`exams/${this.examService.selectedExamIds}/view-script`], {
            queryParams: { excludeTestCandidates: excludeTestCandidates }
          })
        }
      });
   
 }

  examReportList() {
    return [

      {
        icon: 'mat:receipt',
        label: 'Result',
        route: 'report/exam/result',
        id: 'examinations_results'
      },
      {
        icon: 'mat:category',
        label: 'Results by Category',
        route: 'report/exam/result/category',
        id: 'examinations_results_by_category'
      },
      {
        icon: 'mat:settings_ethernet',
        label: 'Results by Period',
        route: 'report/exam/result/period',
        id: 'examinations_results_by_period'
      },
      {
        icon: 'mat:receipt',
        label: 'Result Cards',
        route: 'report/exam/result/card',
        id: 'examinations_result_cards'
      },
      {
        icon: 'mat:assignment',
        label: 'Questions',
        route: 'report/exam/question',
        id: 'examinations_questions'
      },
      {
        icon: 'mat:print',
        label: 'Generate Mark Sheet',
        route: 'report/exam/mark-sheet',
        id: 'examinations_generate_marksheet'
      },
      // {
      //   icon: 'mat:assignment',
      //   label: 'Export Examination Script',
      //   route: 'report/exam/script',
      //   id: 'examinations_examination_script'
      // },
      {
        icon: 'mat:assignment',
        label: 'Examination Script',
        route: `report/exam/view-script`,
        id:'view_examination_script'
      },
      {
        icon: 'mat:subject',
        label: 'Exam Score By IP',
        route: 'report/exam/scoreip',
        id: 'examinations_scores_by_ip'
      },
      {
        icon: 'mat:subject',
        label: 'Exam Score By MAC Address',
        route: 'report/exam/macAddress',
        id: 'examination_scores_by_mac_address'
      },
      {
        icon: 'mat:assessment',
        label: 'Examination Feeback Analysis Report',
        route: 'report/exam/feedback/1',
        id: 'examinations_examination_feedback_analysis_report'
      },
      {
        icon: 'mat:assessment',
        label: 'Admin Examination Feeback Analysis Report',
        route: 'report/exam/feedback/2',
        id: 'examinations_admin_examination_feedback_analysis_report'
      },
      {
        icon: 'mat:assessment',
        label: 'Examiners Marking Report',
        route: 'report/exam/examinersmarking',
        id: 'examinations_examiners_marking_report'
      },
      {
        icon: 'mat:assessment',
        label: 'Examiners Review Report',
        route: 'report/exam/examinersreview',
        id: 'examinations_examiners_review_report'
      },
      {
        icon: 'mat:assessment',
        label: 'Examination Marking Summary',
        route: 'report/exam/exammarkingsummary',
        id: 'examinations_marking_summary'
      },
      {
        icon: 'mat:assignment',
        label: 'Exam Question Analysis',
        route: `report/exam/question-analysis`,
        id:'examination_question_analysis'
      },
      {
        icon: 'mat:assignment',
        label: 'Exam Question Analysis (Excel)',
        route: `report/exam/question-analysis-excel`,
        id:'examination_question_analysis_excel'
      },
      {
        icon: 'mat:assignment',
        label: 'Psychometric Report',
        route: `report/exam/psychometric-report`,
        id:'examination_psychometric_report'
      },
    ];
  }
}
